import { formatCurrency } from '@crm/shared';
import { Card, CardContent, Spinner } from '@crm/ui';
import { Megaphone, MessageSquare, Scissors, UserRound, Users, Wallet } from 'lucide-react';
import { BarChart, StatCard, WIDGET_GRID } from '@/components';
import { useSubscriberMetrics } from '../api';

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function rotuloDoMes(chave: string): string {
  const [ano, mes] = chave.split('-');

  return `${MESES[Number(mes) - 1] ?? mes}/${ano?.slice(2) ?? ''}`;
}

export function SubscriberMetrics({ id }: { id: string }) {
  const metrics = useSubscriberMetrics(id);

  if (metrics.isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  const dados = metrics.data;
  if (!dados) return null;

  const clientes = dados.customers.active + dados.customers.inactive;

  return (
    <div className="space-y-4">
      <div className={WIDGET_GRID.four}>
        <StatCard
          title="Servicos ativos"
          shortTitle="Servicos"
          value={dados.services}
          icon={<Scissors />}
        />
        <StatCard title="Profissionais" value={dados.professionals} icon={<UserRound />} />
        <StatCard
          title="Clientes ativos"
          shortTitle="Ativos"
          value={dados.customers.active}
          hint={`de ${clientes} cadastrados`}
          icon={<Users />}
        />
        <StatCard
          title="Clientes inativos"
          shortTitle="Inativos"
          value={dados.customers.inactive}
          hint="sem atendimento ha 6 meses"
          icon={<Users />}
        />
        <StatCard
          title="Campanhas no mes"
          shortTitle="Campanhas"
          value={dados.campaignsThisMonth}
          icon={<Megaphone />}
        />
        <StatCard
          title="Mensagens no mes"
          shortTitle="Mensagens"
          value={dados.messagesThisMonth}
          icon={<MessageSquare />}
        />
        <StatCard
          title="Saldo de creditos"
          shortTitle="Creditos"
          value={formatCurrency(dados.creditBalance)}
          icon={<Wallet />}
        />
      </div>

      <Card variant="flush">
        <CardContent className="space-y-4 py-5">
          <p className="text-sm font-medium">Faturamento mensal</p>

          <BarChart
            data={dados.revenue.map((mes) => ({
              label: rotuloDoMes(mes.month),
              values: { total: mes.total },
            }))}
            series={[{ key: 'total', label: 'Faturamento', color: 'bg-primary' }]}
            formatValue={formatCurrency}
            emptyLabel="Nenhum atendimento concluido nos ultimos doze meses"
          />
        </CardContent>
      </Card>
    </div>
  );
}
